module.exports = __webpack_public_path__ + "static/media/organisation-d-ateliers-citoyen-sur-des-grands-sujets-de-societe.3770c99a.jpg";